import { compose, createStore, applyMiddleware, Middleware } from "redux";
import { persistStore, persistReducer, createTransform } from "redux-persist";
import storage from "redux-persist/lib/storage";

import logger from "redux-logger";

import thunk from "redux-thunk";

import { rootReducer } from "./root-reducer";
import { CartState } from "./cart/cart.reducer";
import { sanitizeScheduledTime } from "../utils/utils.common";

export type RootState = ReturnType<typeof rootReducer>;
declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose
  }
}

const sanitizeCartScheduledTimeTransform = createTransform(
  (inboundState: CartState) => inboundState,
  (outboundState: CartState) => {
    if (!outboundState) {
      return outboundState;
    }

    return {
      ...outboundState,
      scheduledTime: sanitizeScheduledTime(outboundState.scheduledTime),
    };
  },
  { whitelist: ["cart"] }
);

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["user"],
  transforms: [sanitizeCartScheduledTimeTransform],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const middleWares = [
  process.env.NODE_ENV !== "production" && logger,
  thunk,
].filter((middleware): middleware is Middleware => Boolean(middleware));

const composeEnhancer =
  (process.env.NODE_ENV !== "production" &&
    window &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const composeEnhancers = composeEnhancer(applyMiddleware(...middleWares));

export const store = createStore(persistedReducer, undefined, composeEnhancers);

// export const store = configureStore({
//   reducer: persistedReducer,
//   devTools: process.env.NODE_ENV !== 'production',
//   middleware: [thunk]
// })

export const persistor = persistStore(store);
